import { render } from "./ServiceCell.vue?vue&type=template&id=4afd6363&scoped=true"
import script from "./ServiceCell.vue?vue&type=script&lang=js"
export * from "./ServiceCell.vue?vue&type=script&lang=js"

import "./ServiceCell.vue?vue&type=style&index=0&id=4afd6363&scoped=true&lang=css"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afd6363"]])

export default __exports__